/**
 * Created by piotr.pozniak@thebeaverhead.com on 24/09/2021.
 */
import { useAppStore } from "../../../../../hooks/redux/app";
import { useFeatureFlag } from "../../../../../hooks/useFeatureFlag";

export function useBecomeAffiliateAlert() {
  const { dismissedAlerts } = useAppStore();
  const showAffiliates = useFeatureFlag("showAffiliates");

  if (!showAffiliates) {
    return null;
  }

  if (dismissedAlerts.collection.includes("becomeAffiliate")) {
    return null;
  }

  return {
    id: "becomeAffiliate",
    variant: "promo",
    icon: "Gift01",
    body: "Earn 30% of every subscription you refer.",
    action: { label: "Join the affiliate program", to: "/affiliate#share-earn" },
    dismissible: true,
  };
}

export default useBecomeAffiliateAlert;
